import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { useError, useLoader, useNotification, useCreateAiDiscoverability, useGoogleMapApi, } from "@piiqtechnologies/ui-lib";
import { useCreateAiDiscoverabilityAssessment } from "@piiqtechnologies/ui-lib/lib/apis/ai-discoverability/useCreateAiDiscoverabilityAssessment";
import messages from "./messages.i18n";
import { AiDiscoverabilityFormInitialValues, AiDiscoverabilityFormValidationSchema, getAiDiscoverabilityFormFields, } from "./AiDiscoverabilityConfig";
import { Divider } from "@mui/material";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
export const AiDiscoverabilityForm = ({ onResult }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const { mapAPiloaded } = useGoogleMapApi();
    const [createAiDiscoverability, aiDiscoverabilityCreated, createAiDiscoverabilityInProgress, createAiDiscoverabilityError,] = useCreateAiDiscoverability();
    const [createAiDiscoverabilityAssessment, aiDiscoverabilityAssessmentCreated, createAiDiscoverabilityAssessmentInProgress, createAiDiscoverabilityAssessmentError,] = useCreateAiDiscoverabilityAssessment();
    useEffect(() => {
        setLoader(createAiDiscoverabilityInProgress, "createAiDiscoverabilityInProgress");
        return () => setLoader(false, "createAiDiscoverabilityInProgress");
    }, [createAiDiscoverabilityInProgress]);
    useEffect(() => {
        setLoader(createAiDiscoverabilityAssessmentInProgress, "createAiDiscoverabilityAssessmentInProgress");
        return () => setLoader(false, "createAiDiscoverabilityAssessmentInProgress");
    }, [createAiDiscoverabilityAssessmentInProgress]);
    useEffect(() => {
        if (createAiDiscoverabilityError)
            setError(createAiDiscoverabilityError === null || createAiDiscoverabilityError === void 0 ? void 0 : createAiDiscoverabilityError.message);
    }, [createAiDiscoverabilityError]);
    useEffect(() => {
        if (createAiDiscoverabilityAssessmentError)
            setError(createAiDiscoverabilityAssessmentError === null || createAiDiscoverabilityAssessmentError === void 0 ? void 0 : createAiDiscoverabilityAssessmentError.message);
    }, [createAiDiscoverabilityAssessmentError]);
    useEffect(() => {
        if (aiDiscoverabilityCreated) {
            setNotification(intl.formatMessage(messages.aiDiscoverabilityResultsSuccessfulTitle));
            onResult(aiDiscoverabilityCreated);
        }
    }, [aiDiscoverabilityCreated]);
    useEffect(() => {
        if (aiDiscoverabilityAssessmentCreated) {
            setNotification(intl.formatMessage(messages.aiDiscoverabilityResultsSuccessfulTitle));
            onResult(aiDiscoverabilityAssessmentCreated);
        }
    }, [aiDiscoverabilityAssessmentCreated]);
    const getAddressValue = (address) => {
        if (!address)
            return undefined;
        if (typeof address === "string")
            return address;
        return address.description || address.name;
    };
    const onCreateAiDiscoverability = (values) => {
        createAiDiscoverability(Object.assign(Object.assign({}, values), { communityAddress: getAddressValue(values.communityAddress) }));
    };
    const onCreateAiDiscoverabilityAssessment = (values) => {
        createAiDiscoverabilityAssessment(Object.assign(Object.assign({}, values), { communityAddress: getAddressValue(values.communityAddress) }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Formik, { initialValues: AiDiscoverabilityFormInitialValues, validationSchema: AiDiscoverabilityFormValidationSchema(), onSubmit: () => { } }, ({ values, isValid, dirty }) => (React.createElement(Form, null,
            React.createElement(PeekStack, { gap: 1 },
                React.createElement(PeekTypography, { variant: "h3" }, intl.formatMessage(messages.aiDiscoverabilityFormTitle)),
                React.createElement(Divider, { light: true }),
                React.createElement(MultiColumnFormFields, { fields: getAiDiscoverabilityFormFields(mapAPiloaded) }),
                React.createElement(PeekStack, { direction: "column", gap: 1 },
                    React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "contained", disabled: !isValid || !dirty, onClick: () => onCreateAiDiscoverability(values) }, intl.formatMessage(messages.aiDiscoverabilitySubmitButtonLabel)),
                    React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "contained", disabled: !isValid || !dirty, onClick: () => onCreateAiDiscoverabilityAssessment(values) }, intl.formatMessage(messages.aiDiscoverabilityAssessmentButtonLabel)))))))));
};
export default AiDiscoverabilityForm;
